import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_circle",
  "use": "svg_circle-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"svg_circle\"><circle cx=\"18\" cy=\"18\" r=\"14\" stroke-width=\"6\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol